import { ReportsIcon } from 'foundations-assets';
import { Text } from 'foundations-components/components/Text';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Header } from 'foundations-components/transitional/components/Header';
import { MediaObject } from 'foundations-components/transitional/components/MediaObject';
import { jsx as _jsx } from "react/jsx-runtime";
const SearchResultsHeader = props => {
  const {
    headerKey
  } = props;
  return /*#__PURE__*/_jsx(Header, {
    paddingBlockEnd: "400",
    paddingBlockStart: "0",
    "data-test-id": "results-section-header",
    flush: true,
    headingLevel: 'h2',
    use: "condensed",
    title: /*#__PURE__*/_jsx(MediaObject, {
      align: 'center',
      spacing: "extra-small",
      itemLeft: /*#__PURE__*/_jsx(ReportsIcon, {
        size: "700",
        color: "icon-core-subtle"
      }),
      children: /*#__PURE__*/_jsx(Text, {
        typography: "heading-400",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: headerKey
        })
      })
    })
  });
};
export default SearchResultsHeader;